// index.ts
import { CRUDL, installExtension, reviveJson } from "@juitnow/lib-fetch-client";
var CommentsImpl = class {
  _crudl;
  _bucket;
  constructor(http) {
    this._crudl = new CRUDL(http, "/comments/v1");
    this._bucket = this._crudl.http.environment === "production" ? (
      /* coverage ignore next */
      "juit-backend-cache-prod"
    ) : "juit-backend-cache-dev";
  }
  create(body) {
    return this._crudl.create(body);
  }
  delete(uuid) {
    return this._crudl.delete(uuid);
  }
  async list(q) {
    function isQuery(data) {
      return data !== void 0 && !data.order_uuid;
    }
    if (isQuery(q) && q.offset === 0 && q.limit === 50 && q.visible === true && q.min_order_sequence === 2 && q.empty === false) {
      try {
        const response = await fetch(`https://${this._bucket}.s3.eu-central-1.amazonaws.com/comments/latest.json`);
        if (response.ok) return await response.text().then((data) => JSON.parse(data, reviveJson));
      } catch {
      }
    }
    return this._crudl.list(q);
  }
  update(uuid, updates) {
    return this._crudl.update(uuid, updates);
  }
  async stats() {
    try {
      const response2 = await fetch(`https://${this._bucket}.s3.eu-central-1.amazonaws.com/comments/stats.json`);
      if (response2.ok) return await response2.text().then((data) => JSON.parse(data, reviveJson));
    } catch {
    }
    const response = await this._crudl.http.get("/comments/v1/stats");
    return response.data;
  }
};
installExtension("comments", CommentsImpl);
export {
  CommentsImpl
};
//# sourceMappingURL=index.mjs.map
